module.exports = __webpack_public_path__ + "static/media/binance.e63ca3b4.svg";